import React, { useEffect, useState } from "react";
import { MdOutlineArrowBackIos, MdOutlineArrowForwardIos } from "react-icons/md";
import { getAllProducts } from "../apis/config";
import ProductCard from "./ProductCard";
import ProductSkeleton from "./UI/ProductSkeleton";

const RecentView = ({ product }) => {
  const [startIndex, setStartIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(getDisplayCount());
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Helper to determine responsive display count
  function getDisplayCount() {
    if (typeof window !== "undefined") {
      if (window.innerWidth < 640) return 2;
      if (window.innerWidth < 1024) return 3;
    }
    return 4;
  }

  // Fetch related products on mount
  useEffect(() => {
    if (!product?.category) return;

    getAllProducts()
      .then((res) => {
        const related = res.data.filter(
          (pro) => pro.category === product.category && pro._id !== product._id
        );
        setProducts(related);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [product]);

  // Adjust display count & startIndex on resize
  useEffect(() => {
    const handleResize = () => {
      const count = getDisplayCount();
      setItemsPerPage(count);
      setStartIndex((prevIndex) =>
        Math.min(prevIndex, Math.max(0, products.length - count))
      );
    };

    handleResize(); // initial call
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [products]);

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(prev - itemsPerPage, 0));
  };

  const handleNext = () => {
    setStartIndex((prev) =>
      Math.min(prev + itemsPerPage, products.length - itemsPerPage)
    );
  };

  const visibleProducts = products.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="w-full py-5 p-5 md:px-10">
      <div className="text-left">
        <h3 className="text-[25px] font-bold">Related Products</h3>
      </div>

      <div className="flex py-10 relative gap-3 overflow-hidden">
        {loading
          ? Array(itemsPerPage)
              .fill(0)
              .map((_, idx) => <ProductSkeleton key={idx} />)
          : visibleProducts.map((data, index) => (
              <ProductCard key={data._id || index} data={data} />
            ))}

        {startIndex > 0 && (
          <button
            onClick={handlePrev}
            className="absolute left-0 top-1/2 z-20 bg-black text-white p-1 py-3 hover:bg-red-600"
          >
            <MdOutlineArrowBackIos />
          </button>
        )}

        {startIndex + itemsPerPage < products.length && (
          <button
            onClick={handleNext}
            className="absolute right-0 top-1/2 z-20 bg-black text-white p-1 py-3 hover:bg-red-600"
          >
            <MdOutlineArrowForwardIos />
          </button>
        )}
      </div>
    </div>
  );
};

export default RecentView;
